import IconChooser from './IconChooser.vue'
export default IconChooser
